var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { deprecatedProp as deprecated } from './utils';
// from npm package react-material-snackbar which would not build
const SnackBar = props => {
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [localHeight, setLocalHeight] = useState(60);
    const { show, delay, onHideSnackbar, className, style, status, bsStyle } = props, rest = __rest(props, ["show", "delay", "onHideSnackbar", "className", "style", "status", "bsStyle"]);
    const el = useRef(null);
    const hideSnackbar = useCallback(() => {
        setShowSnackBar(false);
        onHideSnackbar && onHideSnackbar();
    }, [onHideSnackbar]);
    const setHeight = () => {
        if (el && el.clientHeight && localHeight !== el.clientHeight) {
            setLocalHeight(el.clientHeight);
        }
    };
    useEffect(() => {
        setShowSnackBar(show);
        const timer = delay && show ? setTimeout(hideSnackbar, delay) : null;
        return () => clearTimeout(timer);
    }, [delay, hideSnackbar, show]);
    let icon;
    switch (status || bsStyle || 'success') {
        case 'info':
            icon = 'fa-info-circle';
            break;
        case 'success':
            icon = 'fa-check';
            break;
        case 'warning':
        case 'danger':
            icon = 'fa-exclamation-triangle';
            break;
        default:
            icon = 'fa-info-circle';
    }
    const snackbarStyle = Object.assign({ position: 'fixed', left: 0, right: 0, top: `-${localHeight + 30}px`, transitionTimingFunction: 'ease-in-out', transition: '300ms', transform: showSnackBar ? `translateY(${localHeight + 50}px)` : 'translateY(0px)', zIndex: '2000', visibility: showSnackBar ? 'visible' : 'hidden' }, style);
    setHeight();
    const snackbarNode = (React.createElement("div", Object.assign({ className: cx(`snackbar snackbar-${status || bsStyle || 'success'}`, className), style: snackbarStyle }, rest),
        React.createElement("div", { className: "snackbar-icon" },
            React.createElement("i", { className: `fa ${icon}` })),
        React.createElement("div", { className: "snackbar-text" }, props.children),
        React.createElement("button", { type: "button", className: "close", "aria-hidden": "true", onClick: hideSnackbar }, "\u00D7")));
    return ReactDOM.createPortal(snackbarNode, document.body);
};
SnackBar.defaultProps = {
    show: false,
};
SnackBar.propTypes = {
    status: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
    show: PropTypes.bool,
    delay: PropTypes.number,
    children: PropTypes.node,
    onHideSnackbar: PropTypes.func,
    bsStyle: deprecated(PropTypes.oneOf(['success', 'info', 'warning', 'danger']), 'Use `status` instead.'),
};
export default SnackBar;
